/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
/* eslint-disable react/jsx-key */
import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ColorRing } from 'react-loader-spinner';
import Modal from 'react-responsive-modal';
import CustomErrorPopup from "../../../../components/CustomErrorPopup/CustomErrorPopup";
import S3UploadHook from "../../../../CommonMethods/S3UploadHook";
import GlobalContext from "../../../../components/Context/GlobalContext";
import ErrorToast from "../../../../components/Toast/ErroToast";

export default function BulkUpload({ isLoading, setIsLoading, modalpopup, setmodalpopup, setprogressCount, S3FilePrefix, sampleFileName, addDetails, bulkUploadFor, invalidHeader }) {

    const navigate = useNavigate();
    const { email } = useParams();
    const { sideBar } = useContext(GlobalContext)
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState('');

    function isNotExcelFile(filename) {
        const lowercasedFilename = filename.toLowerCase();
        return !lowercasedFilename.endsWith(".xls") && !lowercasedFilename.endsWith(".xlsx");
    }

    async function handleImport(e) {
        setIsLoading(true);
        setToastMessage('');
        setToastType('');
        let file = e.target.files[0];

        
        e.target.value = null;

        // Check if file exists
        if (!file) {
            setIsLoading(false);
            return;
        }

        // **File size validation (50MB limit)**
        const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB in bytes
        if (file.size > MAX_FILE_SIZE) {
            setToastMessage("File size exceeded. Please ensure your file is less than 50MB.");
            setToastType("error");
            setIsLoading(false);
            return;
        }


        let url = ''
        if (isNotExcelFile(file?.name)) {
            setIsLoading(false);
            return;
        }
        if (file.name && file.type) {
            url = await S3UploadHook(file, `${S3FilePrefix}/${encodeURIComponent(email)}`, setprogressCount);
            url = 'public/' + url
            let body = {
                s3_key: url,
                merchant_email_address: email
            }
            addDetails(body, file.name);
        }
        e.target.value = null;
    }

    const handleClose = () => {
        setmodalpopup(prevState => {
            return { ...prevState, open: false }
        });
    }

    useEffect(() => {

    }, []);

    return (
        <>
            <div className={`${sideBar ? 'w-customw2 ml-[70px]' : 'w-customw1 ml-[225px]'} flex-grow  w-full overflow-x-hidden`}>
                <div className="shadow-custom pt-5 pb-5  bg-white fixed w-full z-10">
                    <p className="text-[#4B4B4B] pb-4 pl-8">
                        <span className="text-sm font-normal text-[#8E8E8E]">
                            Merchants / Merchant Details /{" "}
                        </span>
                        Import Files
                    </p>
                    <div className="flex items-center space-x-[14px] pl-6">
                        <img src="/assets/images/chevron-left.svg" alt="" onClick={() => navigate(-1)} />
                        <h1 className="font-playfair text-[#4B4B4B] text-xl font-medium">
                            Import Files
                        </h1>
                    </div>
                </div>
                <div className="bg-[#f5f5f5] pl-[2px] pt-[7px] pb-[8px] mt-[100px] overflow-auto">
                    <div className="bg-white h-[calc(100vh-130px)] rounded items-center flex justify-center mx-4 mt-3 mb-0">
                        <div className="flex justify-center h-full w-full max-w-[781px] max-h-[333px] p-[21px] items-center border border-[#F7D7E8] m-auto rounded-[6px]">
                            <div className="border-dashed border-2 border-[#9E9E9E] h-full w-full rounded-[6px] flex justify-center items-center flex-col">
                                <img src="/assets/images/Import_Icon.svg" className="cursor-default" />
                                <div className="text-[#1F1F1F] font-[400] text-[16px] leading-[24px] text-center mt-[11px] cursor-default">
                                    Click below to upload a file to add {bulkUploadFor} <br />
                                    File format: xlsx,xls
                                </div>
                                <input
                                    type="file"
                                    id="fileInput"
                                    accept=".xlsx"
                                    data-allowed-file-extensions=".xlsx"
                                    onChange={(e) => handleImport(e)}
                                    disabled={isLoading}
                                    style={{ display: 'none' }}
                                />
                                <label htmlFor="fileInput" className="bg-[#9E2064] w-[44px] h-[44px] my-[13px] p-2 rounded-[6px] cursor-pointer flex justify-center items-center">
                                    {isLoading ? <ColorRing
                                        visible={true}
                                        height="25"
                                        width="25"
                                        ariaLabel="blocks-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="blocks-wrapper"
                                        colors={['#fff', '#fff', '#fff', '#fff', '#fff']}
                                    /> : <img src="/assets/images/Add_Icon.svg" />}
                                </label>
                                <div className="text-[#1F1F1F] font-[400] text-[16px] leading-[24px] text-center cursor-default">
                                    <a download href={`/assets/sample_files/${sampleFileName}.xlsx`} className="text-[#0172E4]">
                                        Click here
                                    </a>
                                    {' '}to download the sample file
                                    <p className="mx-[20px] " >Note: The file size for the store logo must be up to 5MB, and the recommended dimensions should be 104*104 px</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <Modal open={modalpopup.open} onClose={handleClose} closeIcon={<div style={{ color: 'white' }} disabled></div>}>
                <div className='errorModal'>
                    <CustomErrorPopup
                        handleClose={handleClose}
                        fileName={modalpopup.fileName}
                        error_index={modalpopup.error_index}
                        invalidHeader={invalidHeader}
                    />
                </div>
            </Modal>
            {toastMessage && (
                <ErrorToast closeIcon message={toastMessage} type={toastType} setToastmessage={setToastMessage} />
            )}
        </>
    );
}
